import {
  Breadcrumb,
  BreadcrumbIcon,
  BreadcrumbLink,
  BreadcrumbPage,
  Button,
} from '@ads/components-react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface IndividualPaymentListTemplateProps {
  readonly filterPanel?: ReactNode;
  readonly children: ReactNode;
  readonly onCreate?: () => void;
}

/**
 * Layout da tela de pesquisa de Pagamento Individual: breadcrumb, page header
 * com as ações, slot de filtros e slot de conteúdo (a tabela).
 */
export function IndividualPaymentListTemplate({
  filterPanel,
  children,
  onCreate,
}: IndividualPaymentListTemplateProps) {
  const { t } = useTranslation('individualPayment');

  return (
    <div className="flex flex-col gap-xs">
      <div className="flex flex-col gap-nano">
        <Breadcrumb>
          <BreadcrumbLink href="/">
            <Link to="/">
              <BreadcrumbIcon />
            </Link>
          </BreadcrumbLink>
          <BreadcrumbPage>{t('breadcrumb')}</BreadcrumbPage>
        </Breadcrumb>

        <div className="flex flex-wrap items-start justify-between gap-xs">
          <div className="flex flex-col gap-quark">
            <h1 className="ts-heading-lg text-ctx-content-title">{t('title')}</h1>
            <p className="ts-paragraph-xs text-ctx-content-base">{t('subtitle')}</p>
          </div>
          <div className="flex shrink-0 gap-xs">
            <Button hierarchy="primary" size="md" leadingIcon={PlusIcon} onClick={onCreate}>
              {t('actions.create')}
            </Button>
          </div>
        </div>
      </div>

      {filterPanel && (
        <div className="rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1">
          {filterPanel}
        </div>
      )}

      {children}
    </div>
  );
}
